import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {employeeRoles, employeeStatus} from "../../models/handbook"
import {AxiosError} from "axios"


interface HandbookState {
  isLoading: boolean
  employeeRoles: employeeRoles,
  employeeStatuses: employeeStatus[],
  error: any
}

const initialState: HandbookState = {
  isLoading: false,
  employeeRoles: {},
  employeeStatuses: [],
  error: {}
}

interface HandbookPayload {
  employeeRoles: {}
  employeeStatuses: employeeStatus[]
}

export const handbookSlice = createSlice({
  name: "handbook",
  initialState,
  reducers: {
    fetching(state) {
      state.isLoading = true
    },
    fetchSuccess(state, action: PayloadAction<HandbookPayload>) {
      state.isLoading = false
      state.error = {}
      state.employeeRoles = action.payload.employeeRoles
      state.employeeStatuses = action.payload.employeeStatuses
    },
    fetchError(state, action: PayloadAction<AxiosError>) {
      state.isLoading = false
      state.error = action.payload.message
    },
  }
})

export default handbookSlice.reducer